export const ROUTES = {
  home: '/',
  login: '/login',
  expired: '/expired',
  callback: '/implicit/callback',
};
